<template>
  <div
    class="flex justify-center items-center rounded-full"
    :class="[sizeClass, paddingClass, customClass]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  interface Props {
    size?: string | number;
    padding?: string | number;
    customClass?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    size: 8,
    padding: 2,
    customClass: ''
  });

  const sizeClass = computed(() => {
    if (typeof props.size === 'string') {
      if (props.size.includes('w-') || props.size.includes('h-')) {
        return props.size;
      }
      return `w-${props.size} h-${props.size}`;
    }
    return `w-${props.size} h-${props.size}`;
  });

  const paddingClass = computed(() => {
    if (typeof props.padding === 'string') {
      if (props.padding.includes('p-')) {
        return props.padding;
      }
      return `p-${props.padding}`;
    }
    return `p-${props.padding}`;
  });
</script>
